// frontend/src/components/common/MobileHero.js
//
// Mobile hero summary for the Manager Portal (design language from EOD v2).
// Leads a page with its most important number, plus an optional divided strip
// of secondary stats. Use ONLY on mobile (gate with useIsMobile).
import React from 'react';
import { C } from '../../styles/theme';

const FONT = "'Plus Jakarta Sans', sans-serif";

/**
 * @param {object} props
 * @param {string} props.label              small uppercase caption (e.g. "Total Sales")
 * @param {string|number} props.value       the headline figure
 * @param {boolean} [props.alert]           render the headline in red
 * @param {string} [props.meta]             secondary line under the value
 * @param {Array<{label:string, value:string, tone?:'red'|'green'}>} [props.stats]  divided strip
 * @param {React.node} [props.children]     extra content (e.g. a payment-mix bar)
 */
export default function MobileHero({ label, value, alert, meta, stats = [], children }) {
    return (
        <div style={{ background: C.white, borderRadius: 20, padding: 22, boxShadow: '0 1px 2px rgba(16,24,40,.04), 0 1px 3px rgba(16,24,40,.08)', marginBottom: 12, fontFamily: FONT }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: C.muted }}>{label}</div>
            <div style={{ fontSize: 38, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1, marginTop: 6, color: alert ? C.red : C.ink, fontVariantNumeric: 'tabular-nums' }}>{value}</div>
            {meta && <div style={{ fontSize: 12.5, color: C.mutedLight, marginTop: 8, fontWeight: 500 }}>{meta}</div>}
            {children}
            {stats.length > 0 && (
                <div style={{ display: 'flex', marginTop: 18, paddingTop: 18, borderTop: `1px solid ${C.line}` }}>
                    {stats.map((s, i) => (
                        <div key={i} style={{ flex: 1, minWidth: 0, ...(i > 0 ? { borderLeft: `1px solid ${C.line}`, paddingLeft: 12 } : {}) }}>
                            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: C.mutedLight, marginBottom: 4 }}>{s.label}</div>
                            <div style={{ fontSize: 16, fontWeight: 800, color: s.tone === 'red' ? C.red : s.tone === 'green' ? C.green : C.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontVariantNumeric: 'tabular-nums' }}>{s.value}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
